<template>
    <div class="card">
        <div class="richTable is-simple py-3 px-4">
            <div class="richTable-head d-flex">
                <div>
                    <h2 class="h6">{{ title }}</h2>
                    <p class="a-text m-0">{{ consentDetails }}</p>
                </div>
            </div>
            <div class="richTable-body">
                <consent-row :consents="consents" :mode="'settings'" />
                <div class="d-flex justify-content-end mt-4 w-100">
                    <the-btn
                        class="btn-secondary ml-auto px-4"
                        @click.native="saveUserConsents"
                        :disabled="!changesInConsents || invalidParams"
                    >
                        Zapisz
                    </the-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConsentRow from '@/components/settings/ConsentRow'
export default {
    components: {
        ConsentRow
    },
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        consentDetails: {
            type: String,
            default: ''
        },
        consentCode: {
            type: String,
            default: ''
        }
    },
    computed: {
        changesInConsents() {
            let changes = false
            this.data
                .forEach((e, idx) => {
                    if (this.sourceConsentsCheckboxStates[idx] !== e.state) {
                        changes = true
                    }
                    if (this.sourceConsentsParams[idx]?.value !==
                        e.dict_consents.params[0]?.value) {
                        changes = true
                    }
                })
            return changes
        },
        invalidParams() {
            return this.data
                .some(e => {
                    return e.dict_consents.params?.length &&
                        e.dict_consents.params.some(v => !!v.invalid)
                })
        }
    },

    beforeMount() {
        this.consents = this.data
        this.sourceConsentsCheckboxStates = this.data.map(e => e.state)
        this.sourceConsentsParams = this.data.map(e => e.dict_consents.params[0])
    },

    data() {
        return {
            consents: [],
            sourceConsentsCheckboxStates: [],
            sourceConsentsParams: []
        }
    },
    methods: {
        saveUserConsents() {
            this.$store.dispatch('saveMarketingConsents', {
                consentCode: this.consentCode
            }).then(async () => {
                await this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zapisano zgody'
                })
                const marketingConsents = this.consentCode === 'ECSP'
                    ? this.$store.getters.getMarketingECSPConsents
                    : this.$store.getters.getMarketingConsents
                this.sourceConsentsCheckboxStates = marketingConsents.map(
                    e => e.state
                )
                this.sourceConsentsParams = marketingConsents.map(
                    e => e.dict_consents.params[0]
                )
            })
        }
    }
}
</script>
